
const API_URL = process.env.VUE_APP_API_URL;

export default {
    computed: {
        loginLink() {
            return `${API_URL}/esia-login?redirectUrl=${API_URL + this.$route.fullPath}`;
        },
        logoutLink() {
            return `${API_URL}/esia-logout`;
        }
    }
};
